import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UILink from 'UIComponents/link/UILink';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AnchorContainer = styled.span.withConfig({
  displayName: "ClickableHeader__AnchorContainer",
  componentId: "sc-1qjfrkc-0"
})(["display:flex;padding-left:4px;margin-bottom:-3px;button{opacity:0;transition:opacity 0.3s;&:hover,&:focus{opacity:1;}}"]);
const HeaderContainer = styled.div.withConfig({
  displayName: "ClickableHeader__HeaderContainer",
  componentId: "sc-1qjfrkc-1"
})(["word-break:break-word;&:hover ", " button{opacity:1;}"], AnchorContainer);
function HeaderLink(props) {
  const {
    hash
  } = props;
  const url = `${window.location.origin}${window.location.pathname}#${hash}`;
  return /*#__PURE__*/_jsx(AnchorContainer, {
    children: /*#__PURE__*/_jsx(UICopyButton, {
      hint: I18n.text('developer-docs-shared-components.tooltips.copyAnchorLink'),
      className: "display-flex",
      use: "unstyled",
      value: url,
      children: /*#__PURE__*/_jsx(UIIcon, {
        color: BATTLESHIP,
        name: "link",
        size: "xs"
      })
    })
  });
}
function ClickableHeader({
  children,
  className,
  Component,
  id
}) {
  return /*#__PURE__*/_jsx(HeaderContainer, {
    className: className,
    children: /*#__PURE__*/_jsxs(Component, {
      id: id,
      className: "align-center",
      children: [/*#__PURE__*/_jsx(UILink, {
        use: "unstyled",
        href: `#${id}`,
        children: children
      }), /*#__PURE__*/_jsx(HeaderLink, {
        hash: id
      })]
    })
  });
}
export default ClickableHeader;